import React, { FC } from "react"

const Header: FC = (props) => {
  return (
    <h3 className="pb-2 text-lg md:text-xl lg:text-2xl">{props.children}</h3>
  )
}

export default Header
